import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { StatementInfo } from './models/statement-info.model';
import { StatementMetrics } from './models/statement-metrics.model';
import {
  getStatementInfo,
  getStatementInfoFetched,
  getStatementMetrics,
  getStatementMetricsFetched,
} from './statement-data.reducer';

@Injectable()
export class StatementDataStore {
  constructor(private _store: Store<any>) {}

  getStatementInfo(clientId: string): Observable<StatementInfo> {
    return this._store.select(getStatementInfo(clientId));
  }

  getStatementInfoFetched(clientId: string): Observable<boolean> {
    return this._store.select(getStatementInfoFetched(clientId));
  }

  getStatementMetrics(clientId: string): Observable<StatementMetrics> {
    return this._store.select(getStatementMetrics(clientId));
  }

  getStatementMetricsFetched(clientId: string): Observable<boolean> {
    return this._store.select(getStatementMetricsFetched(clientId));
  }
}
